import { render, staticRenderFns } from "./Products_comp.vue?vue&type=template&id=42be4b9d&scoped=true&"
import script from "./Products_comp.vue?vue&type=script&lang=js&"
export * from "./Products_comp.vue?vue&type=script&lang=js&"
import style0 from "./Products_comp.vue?vue&type=style&index=0&id=42be4b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be4b9d",
  null
  
)

export default component.exports